export function productGallery() {
    document.querySelectorAll('[data-product-gallery]').forEach(gallery => {
        const slides = gallery.querySelectorAll('[data-gallery-slide]');
        const thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
        const dots = gallery.querySelectorAll('[data-gallery-dot]');
        if (!slides.length) return;

        const show = index => {
            slides.forEach(s => s.classList.toggle('is-active', s.dataset.gallerySlide === String(index)));
            thumbs.forEach(t => t.classList.toggle('is-active', t.dataset.galleryThumb === String(index)));
            dots.forEach(d => d.classList.toggle('is-active', d.dataset.galleryDot === String(index)));
        };

        thumbs.forEach(thumb => {
            thumb.addEventListener('click', () => show(thumb.dataset.galleryThumb));
        });

        dots.forEach(dot => {
            dot.addEventListener('click', () => show(dot.dataset.galleryDot));
        });
    });
}
